// extracted by mini-css-extract-plugin
module.exports = {"ClinicianName":"member-operations__ClinicianName__ClinicianName","ClinicianName__name":"member-operations__ClinicianName__ClinicianName__name"};